import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-index-consume',
  template: `
    <div class="d-flex">
      <div class="flex-fill"></div>
      <div class="ms-auto">
        <!-- button class="btn btn-zazz-default me-2 rounded-4">
          <fa-icon [icon]="icons.faCalendar" class="me-2"></fa-icon>
          <span>Periodo</span>
        </button -->
      </div>
    </div>
    <div class="d-flex mt-3">
      <div class="flex-fill">
        <div class="card rounded-5 shadow">
          <div class="card-header bg-transparent text-center border-bottom-0">
            <h2 class="mt-2">Consumos</h2>
          </div>
          <div class="card-body">
            <app-small-consume-line-chart></app-small-consume-line-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-3">
      <div class="flex-fill">
        <div class="card rounded-5 shadow">
          <div class="card-header bg-transparent text-center border-bottom-0">
            <h2 class="mt-2">Pagos</h2>
          </div>
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-fill">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="text-center"># Recibo</th>
                      <th class="text-center">Periodo</th>
                      <th class="text-center">Monto</th>
                      <th class="text-end"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let bill of bills | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries}">
                      <td class="align-middle text-center">{{bill?.id}}</td>
                      <td class="align-middle text-center">{{bill?.due_date | date: 'MM-YY' }}</td>
                      <td class="align-middle text-center">{{bill?.total | currency}}</td>
                      <td class="text-end">
                        <div ngbDropdown class="d-inline-block ms-2">
                          <button type="button" class="btn btn-link btn-sm text-dark dropdown-toggle py-1" id="dropdownBasic2" ngbDropdownToggle >
                            <fa-icon [icon]="icons.faEllipsisVertical" class="m-1"></fa-icon>
                          </button>
                          <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                            <button ngbDropdownItem 
                              class="btn btn-outline-primary ms-2" 
                              *ngIf="authService.hasPermission('can_edit_invoices')&&!bill?.invoiced&&!bill?.adv"
                              routerLink="/invoices/create/{{bill?.bill_id}}"
                            >Facturar</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``
})
export class IndexConsumeComponent {
  tenantId: any;
  tenant: any;
  bills: any = [];
  meta: any = {};

  data: any = {
    labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio'],
    datasets: [
      {
        label: 'Consumo',
        data: [65, 59, 80, 81, 56, 55],
        fill: false,
        borderColor: '#4bc0c0',
        tension: 0.1
      }
    ]
  };

  payload: any = {    
    page: 1,
    per_page: 50,
    state: [1,2]
  };

  p: number = 1;

  constructor(
    private store: SettlementsService,
    public icons: IconsService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    public authService: AuthService
  ) {
    this.activeRoute.params.subscribe((params) => {
      this.store.getTenant(params['id']).subscribe((data: any) => {
        this.tenant = data;
        this.payload.unit_id = this.tenant.unit_id;
        this.payload.units = data.units.map((item: any) => item.id);
        // this.payload.status = true;

        this.store.getTransactionsByUnit(this.tenant?.id, this.payload).subscribe((bills: any) => {
          console.log('bills => ', bills);
          this.bills = bills.data;
          this.meta = bills.meta;
        });
      });
    });
  }

}
